// import React, { useEffect, useState } from "react";
// import { Modal, Box, Typography, Button, IconButton } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import { useNavigate } from "react-router-dom";

// const TWO_HOURS = 2 * 60 * 60 * 1000;

// const DashboardRequirementModal = () => {
//   const [open, setOpen] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const checkPopupTime = () => {
//       const lastShownTime = localStorage.getItem(
//         "requirementPopupLastShown"
//       );

//       const currentTime = Date.now();

//       // First time
//       if (!lastShownTime) {
//         setOpen(true);
//         localStorage.setItem(
//           "requirementPopupLastShown",
//           currentTime.toString()
//         );
//         return;
//       }

//       const timeDifference =
//         currentTime - parseInt(lastShownTime, 10);

//       // Show again after 2 hours
//       if (timeDifference >= TWO_HOURS) {
//         setOpen(true);
//         localStorage.setItem(
//           "requirementPopupLastShown",
//           currentTime.toString()
//         );
//       }
//     };

//     // Check when Dashboard loads
//     checkPopupTime();

//     // Check periodically
//     const interval = setInterval(() => {
//       checkPopupTime();
//     }, 60 * 1000); // Check every 1 minute

//     return () => clearInterval(interval);
//   }, []);

//   const handleClose = () => {
//     setOpen(false);
//   };

//   const handlePost = () => {
//     setOpen(false);
//     navigate("/pg-hostel-form");
//   };

//   return (
//     <Modal
//       open={open}
//       onClose={handleClose}
//       aria-labelledby="requirement-modal-title"
//     >
//       <Box
//         sx={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",

//           width: {
//             xs: "90%",
//             sm: "500px",
//           },

//           bgcolor: "#ffffff",
//           borderRadius: "18px",
//           boxShadow: 24,
//           p: {
//             xs: 3,
//             sm: 4,
//           },

//           outline: "none",
//           textAlign: "center",
//         }}
//       >
//         {/* Close Button */}
//         <IconButton
//           onClick={handleClose}
//           sx={{
//             position: "absolute",
//             top: 10,
//             right: 10,
//             color: "#666",
//           }}
//         >
//           <CloseIcon />
//         </IconButton>

//         {/* Icon / Heading */}
//         <Typography
//           sx={{
//             fontSize: "32px",
//             mb: 1,
//           }}
//         >
//           🏠
//         </Typography>

//         <Typography
//           id="requirement-modal-title"
//           sx={{
//             fontSize: {
//               xs: "22px",
//               sm: "26px",
//             },
//             fontWeight: 700,
//             color: "#3D2B1F",
//             mb: 1,
//           }}
//         >
//           Post Your Requirements
//         </Typography>

//         {/* Description */}
//         <Typography
//           sx={{
//             fontSize: "15px",
//             color: "#666",
//             lineHeight: 1.6,
//             mb: 3,
//           }}
//         >
//           Tell us what you need. We'll find the best matches for you.
//         </Typography>

//         {/* Buttons */}
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "center",
//             gap: 2,
//           }}
//         >
//           <Button
//             variant="outlined"
//             onClick={handleClose}
//             sx={{
//               minWidth: "110px",
//               borderRadius: "8px",
//               textTransform: "none",
//               fontWeight: 600,
//               borderColor: "#999",
//               color: "#555",
//             }}
//           >
//             Close
//           </Button>

//           <Button
//             variant="contained"
//             onClick={handlePost}
//             sx={{
//               minWidth: "110px",
//               borderRadius: "8px",
//               textTransform: "none",
//               fontWeight: 600,
//               backgroundColor: "#8B6914",

//               "&:hover": {
//                 backgroundColor: "#6F530F",
//               },
//             }}
//           >
//             Post
//           </Button>
//         </Box>
//       </Box>
//     </Modal>
//   );
// };

// export default DashboardRequirementModal;


import React, { useEffect, useState, useContext, useRef } from "react";
import { Modal, Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import NotificationsIcon from "@mui/icons-material/Notifications";
import StarIcon from "@mui/icons-material/Star";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom"; 
import { AuthContext } from '../../AuthContext/AuthContext';

const FIRST_DELAY = 20 * 1000;        // 20 sec after login
const SECOND_DELAY = 20 * 1000;       // 20 sec after the first popup
const REPEAT_DELAY = 30 * 60 * 1000;  // every 30 min after that

const KEYS = {
  user: "popupUserId",
  start: "popupLoginTime",
  count: "popupShownCount",
  last: "popupLastShown",
};

const clearSchedule = () =>
  Object.values(KEYS).forEach((k) => localStorage.removeItem(k));

const DashboardRequirementModal = () => { 
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);
  const timerRef = useRef(null);


    useEffect(() => {
    // Logged out -> reset schedule
    if (!userId) {
      clearSchedule();
      setOpen(false);
      return;
    }

    // New login (different user or no schedule yet) -> start fresh
    if (localStorage.getItem(KEYS.user) !== String(userId)) {
      clearSchedule();
      localStorage.setItem(KEYS.user, String(userId));
      localStorage.setItem(KEYS.start, Date.now().toString());
      localStorage.setItem(KEYS.count, "0");
    }

    const getNextDue = () => {
      const start = parseInt(localStorage.getItem(KEYS.start), 10);
      const count = parseInt(localStorage.getItem(KEYS.count) || "0", 10);
      const last = parseInt(localStorage.getItem(KEYS.last) || "0", 10);

      if (count === 0) return start + FIRST_DELAY;
      if (count === 1) return last + SECOND_DELAY;
      return last + REPEAT_DELAY;
    };

    const schedule = () => {
      clearTimeout(timerRef.current);
      const wait = Math.max(0, getNextDue() - Date.now());

      timerRef.current = setTimeout(() => {
        const count = parseInt(localStorage.getItem(KEYS.count) || "0", 10);
        localStorage.setItem(KEYS.count, String(count + 1));
        localStorage.setItem(KEYS.last, Date.now().toString());
        setOpen(true);
        schedule(); // plan the next one
      }, wait);
    };

    schedule();

    return () => clearTimeout(timerRef.current);
  }, [userId]);

  const handleClose = () => setOpen(false);

  const handlePost = () => {
    setOpen(false);
    navigate("/pg-hostel-form");
  };

  // Feature data for the 4 columns
  const features = [
    {
      icon: <SearchIcon sx={{ fontSize: "28px", color: "#7A5C43" }} />,
      title: "Get Matched",
      subtitle: "with suitable properties",
    },
    {
      icon: <NotificationsIcon sx={{ fontSize: "28px", color: "#7A5C43" }} />,
      title: "Sellers & Builders",
      subtitle: "will reach you directly",
    },
    {
      icon: <StarIcon sx={{ fontSize: "28px", color: "#7A5C43" }} />,
      title: "100% Free",
      subtitle: "to post your requirement",
    },
    {
      icon: <TrackChangesIcon sx={{ fontSize: "28px", color: "#7A5C43" }} />,
      title: "Save Time",
      subtitle: "Get the best options",
    },
  ];

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="requirement-modal-title"
      sx={{
        backdropFilter: "blur(2px)",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: {
            xs: "92%",
            sm: "520px", // Slightly wider to fit the 4 columns nicely
          },
          bgcolor: "#ffffff",
          borderRadius: "24px",
          boxShadow: "0px 10px 40px rgba(0,0,0,0.1)",
          p: {
            xs: 2,
            sm: 5,
          },
          outline: "none",
          textAlign: "center",
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            color: "#9CA3AF",
            "&:hover": {
              backgroundColor: "#F3F4F6",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Top Illustration (Using an emoji as a placeholder, but you can replace with an <img> tag) */}
        <Box
          sx={{
            fontSize: "64px",
            lineHeight: 1,
            mb: 1,
            display: "inline-block",
            position: "relative",
          }}
        >
          🏡
          {/* Optional: Add a small red dot to mimic the location pin if desired */}
        </Box>

        {/* Heading */}
        <Typography
          id="requirement-modal-title"
          sx={{
            fontSize: {
              xs: "24px",
              sm: "28px",
            },
            fontWeight: 700,
            color: "#2D1B13", // Dark brown from screenshot
            mb: 1,
          }}
        >
          Post Your{" "}
          <span style={{ color: "#A0522D" }}>Requirements</span>
        </Typography>

        {/* Description */}
        <Typography
          sx={{
            fontSize: "16px",
            color: "#6B7280",
            lineHeight: 1.5,
            mb: 1,
            px: { xs: 0, sm: 2 },
          }}
        >
          Tell us what you need. We'll find the best properties and sellers for you.
        </Typography>

        {/* Features Grid (4 Columns) */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 1,
            mb: 1,
            flexWrap: { xs: "wrap", sm: "nowrap" },
          }}
        >
          {features.map((feature, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                flex: 1,
                minWidth: { xs: "45%", sm: "auto" },
                mb: { xs: 1, sm: 0 },
              }}
            >
              {/* Icon Circle */}
              <Box
                sx={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  backgroundColor: "#FDF8F5", // Very light brown/pink background
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 1,
                }}
              >
                {feature.icon}
              </Box>
              {/* Feature Title */}
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: 700,
                  color: "#2D1B13",
                  lineHeight: 1.2,
                  mb: 0.5,
                }}
              >
                {feature.title}
              </Typography>
              {/* Feature Subtitle */}
              <Typography
                sx={{
                  fontSize: "11px",
                  color: "#6B7280",
                  lineHeight: 1.2,
                }}
              >
                {feature.subtitle}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Main CTA Button */}
        <Button
          variant="contained"
          onClick={handlePost}
          startIcon={<DescriptionOutlinedIcon />}
          endIcon={<ArrowForwardIcon />}
          fullWidth
          sx={{
            backgroundColor: "#7A4B2A", // Brown color from screenshot
            color: "#ffffff",
            borderRadius: "12px",
            textTransform: "none",
            fontWeight: 700,
            fontSize: "16px",
            py: 1,
            mb: 1,
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#5E3820",
              boxShadow: "none",
            },
          }}
        >
          Post Your Requirement
        </Button>

        {/* Secondary Button */}
        <Button
          variant="outlined"
          onClick={handleClose}
          fullWidth
          sx={{
            borderColor: "#D1D5DB",
            color: "#374151",
            borderRadius: "12px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: "16px",
            py: 1.5,
            "&:hover": {
              borderColor: "#9CA3AF",
              backgroundColor: "#F9FAFB",
            },
          }}
        >
          Not Now
        </Button>
      </Box>
    </Modal>
  );
};

export default DashboardRequirementModal;